module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "location_a01_ZZH_T34706C01_000_01.jpg",
					"buttonIcon": "icon-shower-location-a01-shower"
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T32114C07_000_01_BATH_first question.jpg",
					"buttonIcon": "icon-shower-location-a02-bath"
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "installation-type",
			"additionalClass": "",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "installation-type_a01_ZZH_T26250C05_000_01.jpg",
					"buttonIcon": "icon-shower-installation-type-a01-exposed",
					"conditions": "location",
					"images": [
						{
							"conditions": "location_opt1",
							"image": "installation-type_a01_ZZH_T27641A02_000_01.jpg"
						}
					]
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-shower-installation-type-a02-exposed-with-concealed",
					"conditions": [
						"!da_dk && !fr_be && !nl_be && !fr_fr && location",
						"nl_be && location_opt0",
						"fr_be && location_opt0"
					],
					"image": "installation-type_a02_ZZH_T26443C18_000_01.jpg",
					"images": [
						{
							"conditions": "location_opt1",
							"image": "installation-type_a02_ZZH_T26443C01_000_01.jpg"
						}
					]
				},
				{
					"text": "question2.option3.text",
					"image": "installation-type_a03_ZZH_T34706C01_000_01.jpg",
					"buttonIcon": "icon-shower-installation-type-a03-concealed",
					"conditions": [
						"location_opt0",
						"location && !nl_be && !fr_be",
						"nl_be && location_opt1",
						"fr_be && location_opt1"
					],
					"images": [
						{
							"conditions": "location_opt1",
							"image": "installation-type_a03_ZZH_T29125C01_000_03.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": true,
			"slug": "operation",
			"additionalClass": "",
			"conditions": "location_opt0 && !installation-type_opt1",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "operation_a01_ZZH_T26250C13_000_01.jpg",
					"images": [
						{
							"image": "operation_a01_29126000.jpg",
							"conditions": "installation-type_opt2"
						}
					],
					"buttonIcon": "",
					"conditions": [
						"location_opt0 && installation-type_opt0",
						"location_opt0 && installation-type_opt2"
					]
				},
				{
					"text": "question3.option2.text",
					"buttonIcon": "",
					"image": "operation_a02_ZZH_T27922C04_000_01.jpg",
					"images": [
						{
							"image": "operation_a02_19959000.jpg",
							"conditions": "installation-type_opt2"
						}
					],
					"conditions": [
						"location_opt0 && installation-type_opt0",
						"location_opt0 && installation-type_opt2"
					]
				},
				{
					"text": "question3.option3.text",
					"image": "operation_a03_ZZH_T23147A02_000_01.jpg",
					"images": [
						{
							"image": "operation_a03_19896000.jpg",
							"conditions": "installation-type_opt2"
						}
					],
					"buttonIcon": "",
					"conditions": [
						"location_opt0 && installation-type_opt0 && nl_be",
						"location_opt0 && installation-type_opt2 && nl_be",
						"location_opt0 && installation-type_opt0 && fr_be",
						"location_opt0 && installation-type_opt2 && fr_be",
						"location_opt0 && installation-type_opt0 && en_gb",
						"location_opt0 && installation-type_opt0 && da_dk",
						"location_opt0 && installation-type_opt2 && da_dk",
						"location_opt0 && installation-type_opt0 && sk_sk",
						"location_opt0 && installation-type_opt2 && sk_sk",
						"location_opt0 && installation-type_opt0 && cs_cz",
						"location_opt0 && installation-type_opt2 && cs_cz",
						"location_opt0 && installation-type_opt0 && es_es",
						"location_opt0 && installation-type_opt2 && es_es",
						"location_opt0 && installation-type_opt0 && it_it",
						"location_opt0 && installation-type_opt2 && it_it",
						"location_opt0 && installation-type_opt0 && ru_ru",
						"location_opt0 && installation-type_opt2 && ru_ru",
						"location_opt0 && installation-type_opt0 && uk_ua",
						"location_opt0 && installation-type_opt2 && uk_ua",
						"location_opt0 && installation-type_opt0 && pl_pl",
						"location_opt0 && installation-type_opt2 && pl_pl",
						"location_opt0 && installation-type_opt0 && hu_hu",
						"location_opt0 && installation-type_opt2 && hu_hu",
						"location_opt0 && installation-type_opt0 && fr_fr",
						"location_opt0 && installation-type_opt2 && fr_fr",
						"location_opt0 && installation-type_opt0 && en_eg",
						"location_opt0 && installation-type_opt0 && en_sa",
						"location_opt0 && installation-type_opt0 && en_cy",
						"location_opt0 && installation-type_opt0 && tr_tr",
						"location_opt0 && installation-type_opt0 && de_de",
						"location_opt0 && installation-type_opt2 && !de_de && !de_ch && !de_at && !fr_ch && !it_ch && !en_gb && !nl_nl",
						"location_opt0 && installation-type_opt0 && de_ch",
						"location_opt0 && installation-type_opt0 && de_at",
						"location_opt0 && installation-type_opt0 && fr_ch",
						"location_opt0 && installation-type_opt0 && it_ch",
						"location_opt0 && installation-type_opt0 && ar_sa",
						"location_opt0 && installation-type_opt2 && ar_sa"
					]
				},
				{
					"text": "question3.option4.text",
					"image": "operation_a04_ZZH_X27058000_003_01.jpg",
					"buttonIcon": "",
					"conditions": "location_opt0 && installation-type_opt0"
				}
			]
		},
		{
			"question": "question4.question",
			"swipeable": true,
			"slug": "control",
			"additionalClass": "",
			"conditions": [
				"operation_opt1",
				"operation_opt2 && !da_dk && !sk_sk && !it_it && !cs_cz && es_es && !de_de && !hu_hu && !fr_fr && !es_es && !pl_pl && !en_eg && !en_sa && !en_cy && !tr_tr && !ru_ru && !uk_ua && !nl_be && !fr_be && !de_at && !de_ch",
				"operation_opt2 && da_dk && installation-type_opt0",
				"operation_opt2 && sk_sk && installation-type_opt0",
				"operation_opt2 && cs_cz && installation-type_opt0",
				"operation_opt2 && de_de && installation-type_opt0",
				"operation_opt2 && hu_hu && installation-type_opt0",
				"operation_opt2 && fr_fr && installation-type_opt0",
				"operation_opt2 && es_es && installation-type_opt0",
				"operation_opt2 && pl_pl && installation-type_opt0",
				"operation_opt2 && en_eg && installation-type_opt0",
				"operation_opt2 && it_it && installation-type_opt0",
				"operation_opt2 && en_sa && installation-type_opt0",
				"operation_opt2 && en_cy && installation-type_opt0",
				"operation_opt2 && tr_tr && installation-type_opt0",
				"operation_opt2 && ru_ru && installation-type_opt0",
				"operation_opt2 && uk_ua && installation-type_opt0",
				"operation_opt2 && nl_be && installation-type_opt0",
				"operation_opt2 && fr_be && installation-type_opt0",
				"operation_opt2 && fr_ch && installation-type_opt0",
				"operation_opt2 && it_ch && installation-type_opt0",
				"operation_opt2 && de_ch && installation-type_opt0",
				"operation_opt2 && de_at && installation-type_opt0",
				"operation_opt2 && ar_sa && installation-type_opt0",
				"operation_opt2 && en_gb",
				"location_opt1 && installation-type_opt0",
				"operation_opt3"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "control_a01_34195001.jpg",
					"buttonIcon": "",
					"conditions": "installation-type_opt0 && operation_opt1"
				},
				{
					"text": "question4.option2.text",
					"buttonIcon": "",
					"image": "control_a02_27922001.jpg",
					"images": [
						{
							"image": "control_a02_26381001.jpg",
							"conditions": "installation-type_opt0 && operation_opt3"
						},
						{
							"image": "control_a02_ZZH_26408000_000_01.jpg",
							"conditions": "installation-type_opt2 && operation_opt1"
						},
						{
							"image": "control_a02_26224001.jpg",
							"conditions": "installation-type_opt0 && operation_opt2"
						}
					],
					"conditions": [
						"operation_opt1",
						"operation_opt2",
						"operation_opt3"
					]
				},
				{
					"text": "question4.option3.text",
					"image": "control_a03_27296002.jpg",
					"images": [
						{
							"image": "control_a03_27421002.jpg",
							"conditions": "installation-type_opt0 && operation_opt3"
						},
						{
							"image": "control_a03_ZZH_28778000_001_01.jpg",
							"conditions": "installation-type_opt2 && operation_opt1"
						},
						{
							"image": "control_a03_27473001.jpg",
							"conditions": "installation-type_opt0 && operation_opt2"
						}
					],
					"buttonIcon": "",
					"conditions": [
						"operation_opt1",
						"operation_opt2 && !nl_nl && !fr_be && !nl_be",
						"operation_opt3"
					]
				},
				{
					"text": "question4.option4.text",
					"image": "control_a04_ZZH_26408000_000_01.jpg",
					"buttonIcon": "",
					"conditions": "location_opt1 && installation-type_opt0"
				},
				{
					"text": "question4.option5.text",
					"image": "control_a05_ZZH_26455000_000_01.jpg",
					"buttonIcon": "",
					"conditions": "location_opt1 && installation-type_opt0 && !en_gb"
				}
			]
		},
		{
			"question": "question5.question",
			"swipeable": true,
			"slug": "shape",
			"conditions": [
				"location_opt0 && installation-type_opt2 && operation_opt0",
				"location_opt1 && installation-type_opt2"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-shape-a01-square",
					"conditions": "installation-type_opt2",
					"images": [
						{
							"conditions": [
								"location_opt0",
								"location_opt1"
							],
							"image": "ZZH_T29126C08_000_01.jpg"
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-shape-a02-round",
					"conditions": "installation-type_opt2",
					"images": [
						{
							"conditions": [
								"location_opt0",
								"location_opt1"
							],
							"image": "ZZH_T29121C08_000_01.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "functionality",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"installation-type_opt0",
				"installation-type_opt1",
				"installation-type_opt2 && shape"
			],
			"options": [
				{
					"id": "functionality_opt0",
					"text": "question6.option1.text",
					"image": "functionality_a01_ZZH_T26250C16_000_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt0 && installation-type_opt0 && operation_opt0",
						"location_opt0 && installation-type_opt1 && !en_gb"
					],
					"images": [
						{
							"conditions": "installation-type_opt1",
							"image": "functionality_a01_ZZH_T26443C13_000_01.jpg"
						}
					]
				},
				{
					"id": "functionality_opt3",
					"text": "question6.option2.text",
					"image": "ZZH_29126000_021_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt0 && installation-type_opt2 && operation_opt0"
					],
					"images": [
						{
							"image": "functionality_a04_ZZH_29121000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt4",
					"text": "question6.option3.text",
					"image": "functionality_a05_ZZH_T26443C13_000_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt1 && installation-type_opt1 && !de_de",
						"location_opt1 && installation-type_opt2"
					],
					"images": [
						{
							"image": "ZZH_29126000_021_01.jpg",
							"conditions": "shape_opt0"
						},
						{
							"image": "functionality_a05_ZZH_29121000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt7",
					"text": "question6.option4.text",
					"image": "ZZH_29126000_021_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt0 && installation-type_opt2 && operation_opt0"
					],
					"images": [
						{
							"image": "functionality_a08_ZZH_29121000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt1",
					"text": "question6.option5.text",
					"image": "functionality_a02_ZZH_T26361C15_000_01.jpg",
					"images": [
						{
							"conditions": "location_opt0 && shape_opt0",
							"image": "functionality_a02_ZZH_29124000_003_01.jpg"
						},
						{
							"conditions": "location_opt0 && shape_opt1",
							"image": "functionality_a02_ZZH_29119000_001_01.jpg"
						},
						{
							"conditions": "location_opt0 && installation-type_opt1",
							"image": "functionality_a02_ZZH_T26446C11_000_01.jpg"
						}
					],
					"buttonIcon": "icon-shower-functionality-a02-square",
					"conditions": [
						"location_opt0 && installation-type_opt0 && operation_opt0 && !en_eg && !en_sa && !en_cy && !tr_tr",
						"!de_de && !de_at && !it_ch && !fr_ch && !de_ch && !en_eg && !en_sa && !en_cy && !tr_tr && !nl_be && !fr_be && !fr_be && location_opt0 && installation-type_opt1",
						"location_opt0 && shape"
					]
				},
				{
					"id": "functionality_opt5",
					"text": "question6.option6.text",
					"image": "functionality_a06_ZZH_T26446C11_000_01.jpg",
					"buttonIcon": "icon-shower-functionality-a02-square",
					"conditions": [
						"location_opt1 && installation-type_opt2",
						"location_opt1 && installation-type_opt1"
					],
					"images": [
						{
							"image": "functionality_a06_ZZH_29124000_003_01.jpg",
							"conditions": "shape_opt0"
						},
						{
							"image": "functionality_a06_ZZH_29119000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt2",
					"text": "question6.option7.text",
					"image": "functionality_a03_ZZH_29123000_005_01.jpg",
					"buttonIcon": "icon-shower-functionality-a03-square",
					"conditions": [
						"location_opt0 && installation-type_opt2"
					],
					"images": [
						{
							"image": "functionality_a03_ZZH_29118000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt6",
					"text": "question6.option8.text",
					"image": "functionality_a07_ZZH_29123000_005_01.jpg",
					"buttonIcon": "icon-shower-functionality-a03-square",
					"conditions": [
						"location_opt1 && installation-type_opt2 && !en_eg && !en_sa && !en_cy && !tr_tr && !de_de && !de_at && !de_ch && !it_ch && !fr_ch",
						"location_opt1 && installation-type_opt2 && shape_opt1 && !de_de && !de_at && !de_ch && !it_ch && !fr_ch"
					],
					"images": [
						{
							"image": "functionality_a07_ZZH_29118000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "color",
			"swipeable": true,
			"conditions": [
				"functionality"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question7.option1.text",
					"image": "",
					"buttonIcon": "",
					"conditions": [
						"installation-type_opt0 && functionality_opt0",
						"installation-type_opt0 && functionality_opt1",
						"installation-type_opt1 && functionality_opt0",
						"installation-type_opt1 && functionality_opt1",
						"installation-type_opt2 && functionality_opt0",
						"installation-type_opt2 && functionality_opt2",
						"shape_opt1 && functionality_opt1",
						"functionality_opt3",
						"installation-type_opt1 && functionality_opt4",
						"shape_opt1 && functionality_opt4",
						"functionality_opt5 && installation-type_opt2",
						"functionality_opt6"
					],
					"images": [
						{
							"conditions": "functionality_opt0",
							"image": "color_a01_ZZH_26254000_001_01.jpg"
						},
						{
							"conditions": "functionality_opt0",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "installation-type_opt1 && functionality_opt1",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "installation-type_opt0 && functionality_opt1",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "installation-type_opt2 && functionality_opt1",
							"image": "color_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "color_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt2 && shape_opt0",
							"image": "color_a01_29123000.jpg"
						},
						{
							"conditions": "functionality_opt2 && shape_opt1",
							"image": "color_a01_29118000.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt0",
							"image": "color_a01_29126000.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt1",
							"image": "color_a01_29121000.jpg"
						},
						{
							"conditions": "functionality_opt4 && installation-type_opt1",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1",
							"image": "color_a01_29121000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "color_a01_29124000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "color_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt0",
							"image": "color_a01_29123000.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt1",
							"image": "color_a01_29118000.jpg"
						}
					]
				},
				{
					"text": "question7.option2.text",
					"image": "",
					"buttonIcon": "",
					"conditions": [
						"location_opt0 && installation-type_opt0",
						"location_opt0 && installation-type_opt1",
						"installation-type_opt1 && functionality_opt4"
					],
					"images": [
						{
							"conditions": "functionality_opt0",
							"image": "color_a02_ZZH_26254LS0_001_01.jpg"
						},
						{
							"conditions": "functionality_opt1",
							"image": "color_a02_ZZH_26450LS0_001_01.jpg"
						},
						{
							"conditions": "functionality_opt4",
							"image": "color_a02_ZZH_26450LS0_001_01.jpg"
						}
					]
				},
				{
					"text": "question7.option3.text",
					"image": "",
					"buttonIcon": "",
					"conditions": [
						"!nl_nl && shape_opt1 && functionality_opt1",
						"shape_opt1 && functionality_opt2",
						"shape_opt1 && functionality_opt3",
						"shape_opt0 && functionality_opt2",
						"shape_opt0 && functionality_opt3",
						"functionality_opt5 && installation-type_opt2",
						"functionality_opt6",
						"shape_opt1 && installation-type_opt1 && functionality_opt4",
						"shape_opt1 && functionality_opt4 && location_opt0",
						"shape_opt1 && functionality_opt4 && !nl_nl"
					],
					"images": [
						{
							"conditions": "functionality_opt2 && shape_opt0",
							"image": "color_a03_29153LS0.jpg"
						},
						{
							"conditions": "functionality_opt2 && shape_opt1",
							"image": "color_a03_29150LS0.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt0",
							"image": "color_a03_29157LS0.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt1",
							"image": "color_a03_29904LS0.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "color_a03_29151LS0.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt0",
							"image": "color_a03_29153LS0.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt1",
							"image": "color_a03_29150LS0.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "color_a03_29156LS0.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "color_a03_29151LS0.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1",
							"image": "color_a03_29904LS0.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "with-holder",
			"swipeable": false,
			"additionalClass": "",
			"options": [
				{
					"id": "with-holder_opt1",
					"text": "question8.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-with-holder-a02-square",
					"conditions": [
						"installation-type_opt2 && shape_opt0 && functionality_opt1",
						"installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0",
						"installation-type_opt2 && functionality_opt5 && color_opt0"
					],
					"images": [
						{
							"conditions": "functionality_opt1 && shape_opt0",
							"image": "with-holder_a02_29125000.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "with-holder_a02_29120000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "with-holder_a02_29125000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "with-holder_a02_29120000.jpg"
						}
					]
				},
				{
					"id": "with-holder_opt0",
					"text": "question8.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-with-holder-a01-square",
					"conditions": [
						"installation-type_opt2 && shape_opt0 && functionality_opt1",
						"installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0",
						"installation-type_opt2 && functionality_opt5 && color_opt0"
					],
					"images": [
						{
							"conditions": "functionality_opt1 && shape_opt0",
							"image": "with-holder_a01_29124000.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "with-holder_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "with-holder_a01_29124000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "with-holder_a01_29119000.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "rail-holder",
			"swipeable": true,
			"additionalClass": "",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-rail-holder-a01-railset",
					"conditions": [
						"functionality_opt2 && color",
						"functionality_opt5 && color_opt2",
						"functionality_opt5 && color_opt0 && with-holder_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt2",
							"image": "27700000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt0",
							"image": "rail-holder_a01_27747000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt2",
							"image": "rail-holder_a01_27368000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt5",
							"image": "rail-holder_a01_27700000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt5",
							"image": "rail-holder_a01_27368000.jpg"
						}
					]
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-rail-holder-a02-holderset",
					"conditions": [
						"functionality_opt2 && color",
						"functionality_opt5 && color_opt2",
						"functionality_opt5 && color_opt0 && with-holder_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt2",
							"image": "26405000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt0",
							"image": "rail-holder_a02_27839000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt2",
							"image": "rail-holder_a02_27369000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt5",
							"image": "rail-holder_a02_26405000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt5",
							"image": "rail-holder_a02_27369000.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question10.question",
			"slug": "head-mounted",
			"swipeable": true,
			"additionalClass": "",
			"options": [
				{
					"text": "question10.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-head-mounted-a01-wallmounted",
					"conditions": [
						"functionality_opt3 && color",
						"functionality_opt7",
						"functionality_opt1 && color_opt2",
						"functionality_opt1 && with-holder",
						"functionality_opt4 && shape_opt0",
						"functionality_opt4 && shape_opt1 && color",
						"functionality_opt7 && location_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt1",
							"image": "head-mounted_a01_26054000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a01_26479000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a01_26479LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt7",
							"image": "head-mounted_a01_26255000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt0",
							"image": "head-mounted_a01_26056000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt2",
							"image": "head-mounted_a01_26171LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a01_26475000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a01_26475LS0.jpg"
						},
						{
							"conditions": "functionality_opt7 && shape_opt0",
							"image": "head-mounted_a01_26060000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt4",
							"image": "head-mounted_a01_26054000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt4 && color_opt0",
							"image": "head-mounted_a01_26056000.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1 && color_opt2",
							"image": "head-mounted_a01_26171LS0.jpg"
						}
					]
				},
				{
					"text": "question10.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-head-mounted-a02-ceilingmounted",
					"conditions": [
						"functionality_opt3 && color",
						"functionality_opt7",
						"functionality_opt1 && color_opt2",
						"functionality_opt1 && with-holder",
						"functionality_opt4 && shape_opt0",
						"functionality_opt4 && shape_opt1 && color",
						"functionality_opt7 && location_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt1",
							"image": "head-mounted_a02_26055000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a02_26481000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a02_26481LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt7",
							"image": "head-mounted_a02_26256000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt0",
							"image": "head-mounted_a02_26057000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt2",
							"image": "head-mounted_a02_26053LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a02_26477000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a02_26477LS0.jpg"
						},
						{
							"conditions": "functionality_opt7 && shape_opt0",
							"image": "head-mounted_a02_26061000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt4",
							"image": "head-mounted_a02_26055000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt4 && color_opt0",
							"image": "head-mounted_a02_26057000.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1 && color_opt2",
							"image": "head-mounted_a02_26053LS0.jpg"
						}
					]
				}
			]
		}
	],
	"conditions": []
};


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_questions.json
// module id = 297
// module chunks = 0